import React from 'react';
import { cn } from '../cn';
const colClass = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 xl:grid-cols-4',
};
/**
 * Responsive filter field grid: 1 column on mobile, `columns` (2–4) from `md` up.
 * Place inside `TableFilterBar` or any filter section; child cells should use `TableFilterField`.
 */
export const TableFilterGrid = ({ className, children, columns = 3, gapClassName = 'gap-4', }) => (React.createElement("div", { className: cn('grid', colClass[columns], gapClassName, className) }, children));
export default TableFilterGrid;
